<template>
  <alert-card
    display="three-line-heading"
    primaryHeading="Next event in"
    :middleHeading="`${daysLeft} days`"
    :lowerHeading="exclamation"
  >
  </alert-card>
</template>
<script>
import AlertCard from "../../../Components/UI/AlertCard.vue";
export default {
  computed: {
    daysLeft() {
      let events = this.$store.getters.events("future", (a, b) => {
        let startTime = (event) => {
          switch (event.api_version) {
            case "9-28-2022":
              return new Date(event.start_time).getTime();
            default:
              return new Date(event.data.startTime).getTime();
          }
        };
        let aStart = startTime(a);
        let bStart = startTime(b);
        return aStart < bStart ? -1 : aStart > bStart ? 1 : 0;
      });
      let soonestEvent = events[0];
      let difference =
        new Date(
          soonestEvent.start_time
            ? soonestEvent.start_time
            : soonestEvent.data.startTime
        ) - new Date();
      return Math.ceil(difference / 1000 / 60 / 60 / 24);
    },
    exclamation() {
      let days = this.daysLeft;
      if (days > 365) {
        return "a ways to go!";
      }
      if (days < 365 && days > 182) {
        return "getting there!";
      }
      if (days < 182 && days > 90) {
        return "get excited!";
      } else {
        return "so close!";
      }
    },
  },
  components: { AlertCard },
};
</script>
<style scoped>
.overdue-invoice-list-item {
  height: 40px;
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
